import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, toggleClass } from '@fretadao/f-js-dom';
import { toMilliseconds } from '@fretadao/f-js-utils';

const TABLE_UPDATE_TIMER = toMilliseconds(10, 'seconds');
const ANIMATION_UPDATE_TIMER = toMilliseconds(2, 'seconds');
const LAST_UPDATE_TARGET = "p[data-reactive-table-target='last-update']";

application.register(
  'reactive-table',
  class extends Controller {
    static targets = ['table'];
    static values = { href: String }

    connect() {
      this.#reloadTable();
    }

    #reloadTable() {
      setInterval(() => this.#request(), TABLE_UPDATE_TIMER);
    }

    #changeElement(response) {
      const reloadedPage = document.createElement('div');
      reloadedPage.innerHTML = response;

      const currentTBody = find('tbody', this.tableTarget);
      const newTBody = this.#getNewTBody(reloadedPage);
      const lastUpdateField = this.#lastUpdateTarget();
      const newLastUpdateField = this.#createNewLastUpdateField(reloadedPage);

      if (newTBody) {
        toggleClass(currentTBody, 'animate-pulse');
        setInterval(() => {
          if (newTBody) currentTBody.replaceWith(newTBody);
          if (newLastUpdateField) lastUpdateField.replaceWith(newLastUpdateField);
        }, ANIMATION_UPDATE_TIMER);
      }
    }

    #lastUpdateTarget() {
      return find(LAST_UPDATE_TARGET);
    }

    #createNewLastUpdateField(reloadedPage) {
      return find(LAST_UPDATE_TARGET, reloadedPage);
    }

    #getNewTBody(reloadedPage) {
      const table = find('#operation-confirmation-table', reloadedPage);
      const newTBody = find('tbody', table);

      return newTBody;
    }

    #href() {
      return this.hasHrefValue ? this.hrefValue : window.location.href;
    }

    async #request() {
      const csrfToken = find("meta[name='csrf-token']").content;
      const config = {
        headers: { 'X-CSRF-Token': csrfToken, 'X-Requested-With': 'XMLHttpRequest' }
      }

      fetch(this.#href(), config)
        .then((response) => response.text().then((res) => this.#changeElement(res)))
    }
  }
);
